<form [formGroup]="representativeForm" class="representative-form">
  <div class="representative-form-fields">
    <div class="representative-form-row">
      <div class="input full-height-width">
        <label for="representative-name-first">First Name</label>
        <input
          id="representative-name-first"
          type="text"
          pInputText
          formControlName="NameFirst"
          data-cy="representative-name-first"
        />
      </div>
      <div class="input full-height-width">
        <label for="representative-name-last">Last Name</label>
        <input
          id="representative-name-last"
          type="text"
          pInputText
          formControlName="NameLast"
          data-cy="representative-name-last"
        />
      </div>
    </div>

    <div class="representative-form-row">
      <ep-email-control
        class="full-height-width"
        formControlName="EmailAddress"
        data-cy="representative-email"
      ></ep-email-control>
      <ep-international-phone-control
        class="full-height-width"
        formControlName="PhoneNumber"
        data-cy="representative-phone"
      ></ep-international-phone-control>
    </div>

    <div class="representative-form-row">
      <div class="input full-height-width">
        <label for="representative-language">Language</label>
        <p-dropdown
          id="representative-language"
          [options]="languageOptions"
          optionLabel="name"
          optionValue="value"
          formControlName="LanguageType"
          data-cy="representative-language"
        ></p-dropdown>
      </div>
    </div>

    <div class="representative-form-row">
      <ep-bitflag-checkbox-group-control
        class="full-height-width"
        label="Permissions"
        [options]="accessTypeOptions"
        formControlName="AccessType"
        data-cy="representative-access-type"
      ></ep-bitflag-checkbox-group-control>

      <ep-bitflag-checkbox-group-control
        class="full-height-width"
        label="Roles"
        [options]="representativeTypeOptions"
        formControlName="RepresentativeType"
        data-cy="representative-type"
      ></ep-bitflag-checkbox-group-control>
    </div>
  </div>
</form>
